(function ($) {
  $(function () {
    const $menuIcon = $('#menu-icon, #menu-icon-small');
    const $menuOverlay = $('.site-menu__overlay');
    const $menuNavigatorsContainer = $('.menu-navigators-container');

    function menuToggleClasses() {
      $menuIcon.toggleClass('is-active');
      $menuOverlay.toggleClass('active');
      $('.site-menu__wrapper').toggleClass('toggled');
      if ($(window).scrollTop() > $('#masthead').outerHeight()) {
        $('.site-menu__wrapper').css({
          'top': $('#masthead-sticky-wrapper').outerHeight() + ($menuNavigatorsContainer.outerHeight() || 0),
          'height': 'calc(100% - ' + ($('#masthead-sticky-wrapper').outerHeight() + ($menuNavigatorsContainer.outerHeight() || 0)) +'px)'
        });
      } else {
        $('.site-menu__wrapper').css({
          'top': $('#masthead').outerHeight() + ($menuNavigatorsContainer.outerHeight() || 0),
          'height': 'calc(100% - ' + ($('#masthead').outerHeight() + ($menuNavigatorsContainer.outerHeight() || 0)) +'px)'
        });
      }
      $('body').toggleClass('overflow-hidden');
    }

    $menuIcon.on('click', function () {
      menuToggleClasses();
    });
    $menuOverlay.on('click', function () {
      menuToggleClasses();
    });
  });

})(jQuery);
